import { render, staticRenderFns } from "./add-param.vue?vue&type=template&id=496386be&scoped=true"
import script from "./add-param.vue?vue&type=script&lang=js"
export * from "./add-param.vue?vue&type=script&lang=js"
import style0 from "./add-param.vue?vue&type=style&index=0&id=496386be&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496386be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('496386be')) {
      api.createRecord('496386be', component.options)
    } else {
      api.reload('496386be', component.options)
    }
    module.hot.accept("./add-param.vue?vue&type=template&id=496386be&scoped=true", function () {
      api.rerender('496386be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/product/topic-list/add-param.vue"
export default component.exports